import * as React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material'
import { darken } from "@mui/system";

import CustomButton from "@components/button/customButton";

export default function InfoDialog({ open, onClose, dialogTitle, dialogDescription, items, type = "info", loading = false, closeText = "Close" }) {
  const typeStyle = {
    info: {
      backgroundColor: "#FFFFFF",
      cancelBtn: {
        color: "#5D5D5D",
        backgroundColor: "#E5E5E5",
        "&:hover": {
          backgroundColor: "#AAAAAA",
        },
      },
      confirmBtn: {
        color: "#FFFFFF",
        backgroundColor: "#7CA7AD",
        "&:hover": {
          backgroundColor: darken("#7CA7AD", 0.15),
        },
      },
    },
    error: {
      backgroundColor: "#FFFAFB",
      cancelBtn: {
        color: "#D13F58",
        backgroundColor: "#FFEBEF",
        "&:hover": {
          backgroundColor: "#FCDEE5",
        },
      },
      confirmBtn: {
        color: "#FFFFFF",
        backgroundColor: "#D13F58",
        "&:hover": {
          backgroundColor: "#C22E4B",
        },
      },
    },
  };

  const handleClose = () => {
    if(!loading)
      onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{ '& .MuiDialog-paper': { maxWidth: '350px', borderRadius: '10px', backgroundColor: typeStyle[type]?.backgroundColor ?? "#FFFFF", } }}
      fullWidth
    >
      <DialogTitle id="alert-dialog-title" fontSize={"0.9rem"} fontWeight={600} color='#202020' textAlign={'center'} sx={{padding: '20px 25px 15px 25px'}}>
        {dialogTitle}
      </DialogTitle>
      <DialogContent sx={{padding: '0px 25px'}}>
        <Typography fontSize={"0.8rem"} fontWeight={400} color='#5D5D5D' textAlign={'center'}>{dialogDescription}</Typography>
        {Array.isArray(items) ? 
          <Typography fontSize={"0.8rem"} fontWeight={600} color='#5D5D5D' textAlign={'center'} paddingTop={"10px"}>{items.join(", ")}</Typography>
        : typeof items === "string" ? 
          <Typography fontSize={"0.8rem"} fontWeight={600} color='#5D5D5D' textAlign={'center'} paddingTop={"10px"}>{items}</Typography>
        : null
        }
      </DialogContent>
      <DialogActions sx={{padding: '20px 25px', justifyContent: 'center'}}>
        <CustomButton 
          loading={loading}
          sx={typeStyle[type]?.confirmBtn}
          onClick={handleClose} 
        >
          {closeText}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};
